module.exports = __webpack_public_path__ + "static/media/3동물권-우리,집.8ab2889d.mp3";